import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"12px","color":"#909399"}
}
const _hoisted_5 = { class: "pagination-container" }

import { ref, reactive, onMounted,getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { getMovieOrderListApi,getMovieOrderDetailApi,refundMovieOrderApi } from '@/apis/order'

export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const {proxy} = getCurrentInstance() as any
const router = useRouter()
// 搜索表单
const searchForm = reactive({
    order_no: '',
    device_no: '',
    cinema: '',
    movie: '',
    status: '',
    created_at: '',
    paid_at: '',
})

// 分页
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(61)

// 订单列表
const orderList = ref([])
const getList = async () => {
    getMovieOrderListApi({
        ...searchForm,
        page: currentPage.value,
        page_size: pageSize.value
    }).then((res:any) => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        orderList.value = data.data
        total.value = data.total
    })
}


// 判断是否可以退款
const canRefund = (row) => {
    // 检查开场时间是否大于当前时间7天
    const baseTime = new Date(row.time).getTime();
    const baseTimePlus7Days = baseTime + 7 * 24 * 60 * 60 * 1000;
    const currentTime = new Date().getTime();
    if ((row.status == 1 || row.status == 2) && currentTime <= baseTimePlus7Days) {
        return true
    }
}

// 搜索
const handleSearch = () => {
    getList()
}

// 分页
const handleSizeChange = (size: number) => {
    pageSize.value = size
    getList()
}

const handleCurrentChange = (current: number) => {
    currentPage.value = current
    getList()
}

// 查看订单
const handleView = (row) => {
    router.push('/order/movie-show?id=' + row.id)
    // dialogTitle.value = '订单详情'
    // isViewMode.value = true
    // getMovieOrderDetailApi({ id: row.id }).then((res:any) => {
    //     const { code, data, msg } = res
    //     if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    //     Object.assign(dialogForm, {...data.order,
    //         order_amount: `总额:${parseFloat(data.order.blance_money)} 实付:${data.order.final_amount} 余额:${data.order.user_money_paid} 红包:${data.order.user_money_paid}`
    //     })
    // })
    // dialogVisible.value = true
}



// 退款订单
const handleDelete = (row) => {
    const refund_amount = (parseFloat(row.user_money_paid) + parseFloat(row.final_amount)).toFixed(2)
    proxy.$confirm(`<div">确认退款金额 ${refund_amount} / ${row.quantity}张，<br>确定后将原路退回</div>`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        refundMovieOrderApi({ order_id: row.id }).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '退款成功' })
            getList()
        })
    })
}

onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: searchForm.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.order_no) = $event)),
        placeholder: "订单号",
        style: {"width":"170px","margin-right":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: searchForm.device_no,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.device_no) = $event)),
        placeholder: "订票手机号",
        style: {"width":"170px","margin-right":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: searchForm.cinema,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.cinema) = $event)),
        placeholder: "影院名称",
        style: {"width":"170px","margin-right":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: searchForm.movie,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.movie) = $event)),
        placeholder: "电影名称",
        style: {"width":"170px","margin-right":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: searchForm.status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.status) = $event)),
        placeholder: "订单状态",
        style: {"width":"170px","margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "待支付",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "待出票",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "已出票",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "出票失败待系统自动退款",
            value: "3"
          }),
          _createVNode(_component_el_option, {
            label: "已退款",
            value: "4"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: searchForm.created_at,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchForm.created_at) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "下单日期",
        style: {"width":"170px","margin-right":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: searchForm.paid_at,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchForm.paid_at) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "支付日期",
        style: {"width":"170px","margin-right":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: orderList.value,
        stripe: "",
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "ID",
            width: "70"
          }),
          _createVNode(_component_el_table_column, {
            prop: "order_no",
            label: "订单号",
            width: "160"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(scope.row.order_no) + " ", 1),
                (scope.row.weipiao_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[8] || (_cache[8] = _createTextVNode(" 合作方单号")),
                      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(scope.row.weipiao_id), 1),
                      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" 供应商: " + _toDisplayString(scope.row.gongyingshang), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "电影/影厅信息",
            width: "200"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", null, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "color9" }, "电影名称：", -1)),
                _createTextVNode(_toDisplayString(scope.row.movie), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "color9" }, "影院名称：", -1)),
                _createTextVNode(_toDisplayString(scope.row.cinema), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "color9" }, "影厅：", -1)),
                _createTextVNode(_toDisplayString(scope.row.saloon), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "color9" }, "座位号：", -1)),
                _createTextVNode(_toDisplayString(scope.row.seats), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "color9" }, "开场时间：", -1)),
                _createTextVNode(_toDisplayString(scope.row.time), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "quantity",
            label: "数量",
            width: "50"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "用户",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "device_no",
            label: "订票手机号",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "piao_money",
            label: "票价",
            width: "50"
          }),
          _createVNode(_component_el_table_column, {
            prop: "service_money",
            label: "服务费",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            prop: "user_money_paid",
            label: "扣余额",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            prop: "final_amount",
            label: "实付",
            width: "70"
          }),
          _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: "下单时间",
            width: "145"
          }),
          _createVNode(_component_el_table_column, {
            prop: "paid_at",
            label: "支付时间",
            width: "145"
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "订单状态",
            width: "80"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.status == '0' ? '待支付' : scope.row.status == '1' ? '已支付' : scope.row.status == '2' ? '已出票' : scope.row.status == '3' ? '出票失败待系统自动退款' : scope.row.status == '4' || scope.row.status == '5' ? '已退款' : '--'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "print_code",
            label: "取票信息"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (handleView(scope.row))
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_tooltip, {
                content: '仅待出票状态或已出票并开场时间距当前时间7天之内的才可以退款',
                placement: "top",
                disabled: canRefund(scope.row)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    disabled: !canRefund(scope.row),
                    onClick: ($event: any) => (handleDelete(scope.row))
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("退款")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "current-page": currentPage.value,
        "page-sizes": [10, 20, 30, 40, 50],
        "page-size": pageSize.value,
        layout: "total, sizes, prev, pager, next, jumper",
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})